import { useEffect } from 'react';

/**
 * Hook to handle Escape key press
 * @param isActive - Whether the escape key handler should be active
 * @param onEscape - Callback function to call when Escape key is pressed
 */
export const useEscapeKey = (isActive: boolean, onEscape: () => void): void => {
  useEffect(() => {
    if (!isActive) return;

    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onEscape();
      }
    };

    document.addEventListener('keydown', handleEscape);
    return () => document.removeEventListener('keydown', handleEscape);
  }, [isActive, onEscape]);
};
